import { render, staticRenderFns } from "./NationalTrademarkResponsibleForm.vue?vue&type=template&id=978c444c&"
import script from "./NationalTrademarkResponsibleForm.vue?vue&type=script&lang=js&"
export * from "./NationalTrademarkResponsibleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports